// src/pages/auth/ForgotPasswordPage.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/auth.service';
import logonegro from '../../assets/images/logonegro.svg';
import fondoPantalla from '../../assets/images/fondo_pantalla.svg';
import '../../assets/styles/auth-common.css';
import Footer from '../../components/layout/footer';
import { useWindow } from '../../context/WindowContext';
const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const { windowWidth } = useWindow();
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState<'EN' | 'ES'>('EN');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email) {
      setError('Please enter your email');
      return;
    }

    try {
      setLoading(true);
      const response = await authService.requestPasswordReset(email);

      if (response.userExists === false) {
        // User doesn't exist - show error message
        setError('No account found with this email address. Please check your email or create a new account.');
        return;
      }

      // User exists - proceed to reset password page
      navigate('/reset-password', { state: { email } });
    } catch (err: any) {
      setError(err.message || 'Error requesting password reset');
    } finally {
      setLoading(false);
    }
  };

  const rootStyle = {
    '--bg-image': `url(${fondoPantalla})`
  } as React.CSSProperties;

  return (
    <div style={{ backgroundColor: '#003DA5', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 20px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px', width: '100%' }}>
        {/* Logo centrado */}
        <div style={{ textAlign: 'center', width: '400px', maxWidth: '90vw' }}>
          <img src={logonegro} alt="Kanz Bank" style={{ width: 'auto', height: '252px', maxWidth: '100%' }} />
        </div>

        {/* Formulario centrado */}
        <form className="auth-form-container" onSubmit={handleSubmit} style={{ width: '400px', maxWidth: '90vw', position: 'relative', zIndex: 10, margin: '0', gridColumn: 'unset' }}>
          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          <div className="verification-info">
            <p>Enter your email address and we will send you a code to reset your password.</p>
          </div>

          <div className="input-group">
            <label htmlFor="email">Email address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              disabled={loading}
              required
            />
          </div>

          <button 
            type="submit" 
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Code'}
          </button>

          <div className="secondary-buttons">
            <button
              type="button"
              className="btn-signup"
              onClick={() => navigate('/signup')}
              disabled={loading}
            >
              Sign Up
            </button>
            <button 
              type="button"
              className="btn-validate"
              onClick={() => navigate('/')}
              disabled={loading}
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>

      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;